/* Fossa footer: mobile accordions (below 750px). One section open at a time.
   Without this script every menu stays expanded. */
(function () {
  var root = document.querySelector('[data-fossa-footer]');
  if (!root || root.dataset.ffReady) return;
  root.dataset.ffReady = '1';

  var mq = window.matchMedia('(max-width: 749px)');
  var cols = Array.prototype.slice.call(root.querySelectorAll('[data-ff-col]'));

  function setOpen(col, open) {
    col.classList.toggle('is-open', open);
    var btn = col.querySelector('[data-ff-toggle]');
    if (mq.matches) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function sync() {
    cols.forEach(function (col) {
      var btn = col.querySelector('[data-ff-toggle]');
      if (mq.matches) {
        btn.removeAttribute('tabindex');
        btn.setAttribute('aria-expanded', col.classList.contains('is-open') ? 'true' : 'false');
      } else {
        btn.removeAttribute('aria-expanded');
        btn.setAttribute('tabindex', '-1');
      }
    });
  }

  cols.forEach(function (col) {
    col.querySelector('[data-ff-toggle]').addEventListener('click', function () {
      if (!mq.matches) return;
      var willOpen = !col.classList.contains('is-open');
      cols.forEach(function (other) { if (other !== col) setOpen(other, false); });
      setOpen(col, willOpen);
    });
  });

  root.classList.add('ff-js');
  sync();
  if (mq.addEventListener) mq.addEventListener('change', sync); else mq.addListener(sync);
})();